import React, {useState, useEffect, useRef} from 'react';
import {ArrowUp} from 'lucide-react';
import $ from "jquery";

const TopScroller = () => {
  // 스크롤 위치에 따라 버튼 표시 여부를 결정하는 상태
  const [isVisible, setIsVisible] = useState(false);
  const [leftPosition, setLeftPosition] = useState(0);
  const [topPosition, setTopPosition] = useState(0);
  const buttonRef = useRef(null);

  // 위치 업데이트 함수
  const updatePosition = () => {
    if ($('#mainContents').length) {
      // 가로 위치 계산
      const mainContentsWidth = $('#LNB').width() + $('#mainContents').width();
      setLeftPosition(mainContentsWidth - 70);

      const windowHeight = parseInt($(window).scrollTop(), 10) + $(window).height();
      setTopPosition(windowHeight - 60); // 하단에서 80px 위에 위치
    }
  };

  // 스크롤 이벤트 핸들러
  useEffect(() => {
    // 스크롤 위치가 300px 이상일 때 버튼 표시
    const toggleVisibility = () => {
      if (window.pageYOffset > 50) {
        setIsVisible(true);
        updatePosition();
      } else {
        setIsVisible(false);
      }
    };

    // 초기 위치 설정
    updatePosition();

    // 스크롤 이벤트 리스너 등록
    window.addEventListener('scroll', toggleVisibility);

    // 리사이즈 이벤트 리스너 등록 (창 크기 변경시 위치 업데이트)
    window.addEventListener('resize', updatePosition);

    // 컴포넌트 언마운트 시 이벤트 리스너 제거
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
      window.removeEventListener('resize', updatePosition);
    };
  }, []);

  // 최상단으로 스크롤 이동시키는 함수
  const scrollToTop = () => {
    window.scrollTo({
      top: 0
    });
  };

  return (
    <>
      {isVisible && (
        <button
          id="topScroller"
          ref={buttonRef}
          onClick={scrollToTop}
          className="p_absolute p-2 bg-white text-gray-700 rounded-lg hover:bg-gray-100 transition-all duration-300 focus:outline-none flex items-center justify-center"
          style={{
            left: `${leftPosition}px`,
            top: `${topPosition}px`,
            width: '50px',
            height: '40px',
            border: '1px solid #e2e8f0',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
            zIndex: 1000
          }}
          aria-label="맨 위로 스크롤"
        >
          <ArrowUp size={20} strokeWidth={2.5} className="text-gray-700"/>
        </button>
      )}
    </>
  );
};

export default TopScroller;
